import { render, staticRenderFns } from "./GameProjectListItem.vue?vue&type=template&id=44bee561"
import script from "./GameProjectListItem.vue?vue&type=script&lang=js"
export * from "./GameProjectListItem.vue?vue&type=script&lang=js"
import style0 from "./GameProjectListItem.vue?vue&type=style&index=0&id=44bee561&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports